// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_babel_runtime_regenerator_index_js-node_modules_single-spa-layout_dist_u-1934e2":"2c08c259838d8427eb82","src_bootstrap_js":"d5882c515dabc6e80b14","vendors-node_modules_single-spa_lib_esm_single-spa_min_js":"77ec034ab9dc4184fee3"}[chunkId] + ".js";
};